import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=5a7df426&scoped=true&"
import script from "./BookingInfo.vue?vue&type=script&lang=js&"
export * from "./BookingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=5a7df426&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7df426",
  null
  
)

export default component.exports